function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export default function createMixins(breakpoints, mixins) {
    var _obj;
    return _object_spread({
        toolbar: (_obj = {
            minHeight: 56
        }, _define_property(_obj, breakpoints.up('xs'), {
            '@media (orientation: landscape)': {
                minHeight: 48
            }
        }), _define_property(_obj, breakpoints.up('sm'), {
            minHeight: 64
        }), _obj)
    }, mixins);
}
